<template>
  <transition name="notification-fade" @leave="onTransitionLeave">
    <div :class="`notification ${type}`">
      <div class="notification-content">
        <p class="notification-message">{{ message }}</p>
        <button v-if="closable" @click="onClose" class="notification-close">
          ×
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">

interface Props {
  message: string
  type?: 'success' | 'error' | 'warning' | 'info'
  closable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  type: 'info',
  closable: true
})

const emit = defineEmits<{
  remove: []
}>()

const onClose = () => {
  emit('remove')
}

const onTransitionLeave = () => {
  // Transition completed
}
</script>

<style scoped>
.notification {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 300px;
  max-width: 400px;
  animation: slideIn 0.3s ease-out;
}

.notification-success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.notification-error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.notification {
  /* position: fixed; */
  /* bottom: 2rem; */
  /* right: 2rem; */
  padding: 1rem 2rem;
  border-radius: 4px;
  font-weight: 500;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.notification.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.notification.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.notification.warning {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.notification.info {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.notification-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.notification-message {
  margin: 0;
}

.notification-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: inherit;
  padding: 0;
  margin-left: 10px;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.notification-close:hover {
  opacity: 1;
}

.notification-fade-enter-active {
  animation: slideIn 0.3s ease-out;
}

.notification-fade-leave-active {
  animation: slideOut 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}
</style>